/* eslint-disable*/
import Cookies from 'js-cookie';
import { useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ajax from '../utils/ajaxHelper';
import { getHostType } from '../utils';
import { getLoggedInUserData } from '../utils/Helper';

const usePractice = () => {
  const loggedInUserData = getLoggedInUserData();
  const { roleId } = useParams();
  const navigate = useNavigate();

  const callAPi = useCallback(
    async (url, values, { setErrors, setStatus, setSubmitting }, callback) => {
      const data = values;
      try {
        await ajax
          .post(url, data, {
            networkParams: { showLoader: false },
            headers: {
              hosttype: getHostType(roleId),
            },
          })
          .then((res) => {
            callback(res);
          });
      } catch (error) {
        setStatus({ success: false });
        setErrors({ submit: error.message });
        callback(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    },
    [roleId],
  );

  const getUsers = useCallback(
    async (url, params, actions, callback) => {
      try {
        await callAPi(url, params, {}, callback);
      } catch (error) {
        console.log('error', error);
      }
    },
    [callAPi],
  );

  const addUser = useCallback(
    async (values) => {
      try {
        return await ajax.post('user/create-user', values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } catch (error) {
        console.log(error, 404);
        // Return the error response so the UI can handle it
        if (error.response && error.response.data) {
          return error.response.data;
        }
        return { status: false, message: error.message };
      }
    },
    [callAPi],
  );

  const updateUser = useCallback(
    async (values) => {
      try {
        return await ajax.post('user/update-user-details', values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } catch (error) {
        console.log(error, 404);
        // Return the error response so the UI can handle it
        if (error.response && error.response.data) {
          return error.response.data;
        }
        return { status: false, message: 'An error occurred while updating the user.' };
      }
    },
    [callAPi],
  );

  const addGlobalGivingCause = useCallback(
    async (values) => {
      try {
        return await ajax.post('global-giving-causes/create', values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
  );

  const fetchAllGlobalGivingCauses = useCallback(async (val) => {
    try {
      let result = await ajax.post(`global-giving-causes/get-all`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCountry = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-country-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getFilterCountryDetails = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-filter-country-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getMasterCountrylist = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-master-country-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCellData = useCallback(async (countryId) => {
    try {
      const val = { countryId: countryId };
      let result = await ajax.post(`user/get-cell-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getCountriesCells = useCallback(async (countryIds) => {
    try {
      const val = { countryIds: countryIds };

      let result = await ajax.post(`user/get-countries-cells`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getDepartmentData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-department-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getAllUsers = useCallback(async () => {
    try {
      const values = { id: loggedInUserData?.id };
      let result = await ajax.post(`user/get-users-list`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getUserDetails = useCallback(async (val, cellId) => {
    try {
      const values = { userId: val, cellId: cellId ? cellId : null };
      let result = await ajax.post(`user/get-user-details`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getUserDetailsByEmail = useCallback(async (val) => {
    try {
      const values = { emailId: val.emailId };
      let result = await ajax.post(`user/get-user-details-by-email`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getAllPerformanceNotes = useCallback(async (val) => {
    try {
      const values = { userId: val };
      let result = await ajax.post(`user/get-user-performance-note`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getUserTotalFilesNotes = useCallback(async (val) => {
    try {
      const values = { userId: val ? val : null };
      let result = await ajax.post(`user/get-user-totalfiles-note`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getAllTotalFilesNotes = useCallback(async (val) => {
    try {
      const values = { userId: val };
      let result = await ajax.post(`user/get-all-totalfiles-note`, values);
      return result;
    } catch (error) {
      return error;
    }
  });
  const getSinglePerformanceNote = useCallback(async (val) => {
    try {
      const values = { noteId: val };
      let result = await ajax.post(`user/get-performance-note`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getSingleTotalFilesNote = useCallback(async (val) => {
    try {
      const values = { noteId: val };
      let result = await ajax.post(`user/get-totalfiles-note`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const deleteUser = useCallback(async (val) => {
    try {
      const value = { id: val };
      let result = await ajax.post(`user/delete-user`, value);
      navigate('/app/employee-directory/:formId');
    } catch (error) {
      return error;
    }
  });

  const addUserPerformanceNote = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('user/add-user-performance-note', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const addUserTotalFilesNote = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('user/add-user-totalfiles-note', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const saveFilter = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('user/save-filter', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const getAllFilters = useCallback(async (val) => {
    try {
      const values = { userId: val?.userId };
      let result = await ajax.post(`user/get-all-filters`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const deleteAllFilters = useCallback(async (val) => {
    try {
      const values = { userId: val?.userId };

      let result = await ajax.post(`user/delete-all-filters`, values);
      return result;
    } catch (error) {
      return error;
    }
  });
  const deleteSelectedFilter = useCallback(async (val) => {
    try {
      const values = { userId: val?.userId, searchId: val?.searchId };

      let result = await ajax.post(`user/delete-selected-filter`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const updateFilterName = useCallback(async (val) => {
    try {
      const values = { id: val?.id, filterName: val?.filterName, userId: val?.userId };
      let result = await ajax.post(`user/update-filter-name`, values);
      return result;
    } catch (error) {
      return error;
    }
  });
  const updateSavedFilter = useCallback(async (val) => {
    try {
      const values = {
        id: val?.id,
        metrics: val?.metrics,
        country: val?.country,
        cell: val?.cell,
        department: val?.department,
        year: val?.year,
        period: val?.period,
      };
      let result = await ajax.post(`user/update-saved-filter`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const updateUserTotalFilesNote = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('user/update-user-totalfiles-note', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const fetchAllCellList = useCallback(async (val) => {
    try {
      const values = { countryId: val?.countryId };
      let result = await ajax.post(`user/get-all-cell-list`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getFilteredGlobalCauseDetails = useCallback(async (val) => {
    try {
      let result = await ajax.post(`global-giving-causes/get-filtered-details`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const deleteGlobalCause = useCallback(async (val) => {
    try {
      const value = { id: val };
      await ajax.post(`global-giving-causes/delete`, value);
    } catch (error) {
      return error;
    }
  });

  const deletePerformanceNote = useCallback(async (val) => {
    try {
      const value = { noteId: val };
      await ajax.post(`user/delete-user-performance-note`, value);
    } catch (error) {
      return error;
    }
  });

  const deleteTotalFilesNote = useCallback(async (val) => {
    try {
      const value = { noteId: val };
      await ajax.post(`user/delete-user-totalfiles-note`, value);
    } catch (error) {
      return error;
    }
  });

  const getNonAlumniUsers = useCallback(async (val) => {
    try {
      const values = { id: val };
      let result = await ajax.post(`user/get-non-alumni-users-list`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const saveEmployeeAnalysisFilter = useCallback(
    async (values) => {
      try {
        const result = await ajax.post('user/save-employee-analysis-filter', values);
        return result;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
    //navigate('/login');
  );

  const getEmployeeAnalysisFilter = useCallback(async (val) => {
    try {
      const values = { userId: val?.userId };
      let result = await ajax.post(`user/get-all-employee-analysis-filter`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const deleteEmployeeAnalysisFilter = useCallback(async (val) => {
    try {
      const values = { userId: val?.userId };

      let result = await ajax.post(`user/delete-employee-analysis-filter`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const updateEmployeeAnalysisFilterName = useCallback(async (val) => {
    try {
      const values = {
        id: val?.id,
        filterName: val?.filterName,
        userId: val?.userId,
      };
      let result = await ajax.post(`user/update-employee-analysis-filter-name`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const deleteSelectedEmployeeAnalysisFilter = useCallback(async (val) => {
    try {
      const values = { userId: val?.userId, searchId: val?.searchId };

      let result = await ajax.post(`user/delete-selected-employee-analysis-filter-name`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const updateEmployeeAnalysisFilter = useCallback(async (val) => {
    try {
      const values = {
        id: val?.id,
        metrics: val?.filter?.fieldoptionid,
        country: val?.filter?.countryid,
        cell: val?.filter?.cellid,
        department: val?.filter?.deptid,
        year: val?.filter?.yearid,
        period: val?.filter?.period,
        filterData: val?.filterData,
      };
      let result = await ajax.post(`user/update-employee-analysis-filter`, values);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getFinancialPerformanceCountryByYear = useCallback(async (val) => {
    try {
      let result = await ajax.post(`user/get-financial-performance-by-year`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getDashboardComments = useCallback(async (val) => {
    try {
      return await ajax.post(`user/get-dashboard-comments`, val);
    } catch (error) {
      return error;
    }
  });

  const updateComment = useCallback(async (val) => {
    try {
      return await ajax.post(`user/update-comment`, val);
    } catch (error) {
      return error;
    }
  });

  const shareFormWithUser = useCallback(async (val) => {
    try {
      return await ajax.post(`user/share-form-with-user`, val);
    } catch (error) {
      return error;
    }
  });

  const updateNewUserDetails = useCallback(
    async (values, isChangedDetails) => {
      try {
        const updateDetails = await ajax.post('user/update-new-user-details', values, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        if (isChangedDetails == 0) {
          setTimeout(() => {
            Cookies.remove('token');
            Cookies.remove('hosttype');
            Cookies.remove('user');
            Cookies.remove('path');
            Cookies.remove('welcomeLoaded');
            location.reload();
          }, 4000);
        } else {
          return updateDetails;
        }
        return updateDetails;
      } catch (error) {
        console.log(error, 404);
      }
    },
    [callAPi],
  );

  return {
    getUsers,
    addUser,
    getCountry,
    getAllUsers,
    getUserDetails,
    getUserDetailsByEmail,
    getDepartmentData,
    getCellData,
    getCountriesCells,
    getAllPerformanceNotes,
    getAllTotalFilesNotes,
    getUserTotalFilesNotes,
    addGlobalGivingCause,
    fetchAllGlobalGivingCauses,
    deleteUser,
    addUserPerformanceNote,
    updateUserTotalFilesNote,
    updateUser,
    addUserTotalFilesNote,
    fetchAllCellList,
    getFilteredGlobalCauseDetails,
    deleteGlobalCause,
    getSinglePerformanceNote,
    getSingleTotalFilesNote,
    deletePerformanceNote,
    deleteTotalFilesNote,
    getMasterCountrylist,
    getNonAlumniUsers,
    getFilterCountryDetails,
    saveFilter,
    getAllFilters,
    updateFilterName,
    updateSavedFilter,
    deleteAllFilters,
    deleteSelectedFilter,
    saveEmployeeAnalysisFilter,
    getEmployeeAnalysisFilter,
    deleteEmployeeAnalysisFilter,
    getFinancialPerformanceCountryByYear,
    updateEmployeeAnalysisFilterName,
    deleteSelectedEmployeeAnalysisFilter,
    updateEmployeeAnalysisFilter,
    getDashboardComments,
    updateComment,
    shareFormWithUser,
    updateNewUserDetails,
  };
};

export default usePractice;
